export const BASE_URL = 'https://researchjournal.alepuniv.edu.sy/data/api';
